import { Input, Select } from 'Components';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { useUserContext } from 'Pages/User/UserContext';
import Layout from './Layout';

const GeneralInfo = ({
	isProfile,
	isAddNewUser,
	openModal
}: {
	isProfile: boolean;
	isAddNewUser: boolean;
	openModal: () => void;
}) => {
	const { t } = useTranslation();
	const { timezones, timezonesList } = useUserContext();
	const { isValid, dirty, setFieldTouched } = useFormikContext();
	const disabled = !(isValid && dirty);

	return (
		<Layout
			title={t(`profile.general.title`)}
			description={t(`profile.general.description`)}
			btnText={isProfile ? t(`saveChanges`) : ''}
			handleNext={openModal}
			btnDisable={disabled}
		>
			<Input.FormikField
				name="firstName"
				label={t('user.firstName')}
				required
			/>
			<Input.FormikField
				name="lastName"
				label={t('user.lastName')}
				required
			/>
			<Input.FormikField name="email" label={t('user.email')} required />
			<Input.FormikField
				name="cognitoLogin"
				label={t('user.cognitoLogin')}
				disabled={!isAddNewUser}
				required
			/>
			<Input.FormikField
				name="phoneNumber"
				label={t('user.phoneNumber')}
				onChange={() => setFieldTouched('phoneNumber', true)}
			/>
			<Select.FormikField
				name="timezoneId"
				label={t('user.timezoneId')}
				required
				loading={timezones.loading}
			>
				{timezonesList?.map((option) => (
					<Select.Option key={option.id} value={option.id}>
						{option.zone}
					</Select.Option>
				))}
			</Select.FormikField>
		</Layout>
	);
};

export default GeneralInfo;
